module.exports = __webpack_public_path__ + "img/download.88b68063.svg";